import { render, staticRenderFns } from "./TransactionsPaymentsUSDT.vue?vue&type=template&id=671de04e&"
import script from "./TransactionsPaymentsUSDT.vue?vue&type=script&lang=js&"
export * from "./TransactionsPaymentsUSDT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports